import React from 'react';
import MuiAppBar from '@mui/material/AppBar';

import { colors } from '../../gatsby-theme-material-ui-top-layout/theme';
import { sxPropType } from '../../proptypes/misc';

function AppBar({ sx, ...rest }) {
  return (
    <MuiAppBar
      elevation={0}
      position="static"
      sx={[
        (theme) => ({
          backgroundColor: colors.grey.dark,
          color: theme.palette.common.white,
          [theme.breakpoints.up('md')]: {
            maxWidth: '1476px',
            margin: '0 auto',

            borderRadius: '39px',
            // margin: '0 42px',
            top: '20px',
            width: 'calc(100% - 84px)',
          },
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...rest}
    />
  );
}

AppBar.propTypes = {
  sx: sxPropType,
};

AppBar.defaultProps = {
  sx: [],
};

export default AppBar;
